<section class="w-full bg-white">
  <div
    class="w-full lg:py-25 py-10 bg-[url(/home/value-bg-mo.svg)] lg:bg-[url(/home/value-bg.svg)] bg-no-repeat bg-contain bg-center mx-auto">
    <div class="flex flex-col w-full container gap-6 lg:gap-0 px-4 lg:px-0">
      <div class="flex flex-col lg:flex-row lg:justify-between gap-2 lg:gap-4 lg:items-center">
        <div class="flex flex-col gap-2 lg:gap-3 text-left">
          <p class="font-extrabold text-sm lg:text-lg text-gradient-primary bg-clip-text text-transparent">VALUE</p>
          <h1 class="text-xl lg:text-4xl lg:leading-14 text-zinc-800">
            <span class="font-extrabold">고객 중심의</span> 글로벌 가치<br />화합과 조화 공존하는 가치
          </h1>
        </div>

        <p class="text-sm text-zinc-500 font-medium lg:text-lg">
          좋은공간은 사람 중심의 화합과 조화를 이루어, 공존하는 가치를 창조하며 혁신적인 지식 경영을<br
            class="hidden lg:flex" />해 나갈 것 입니다.
        </p>
      </div>
      <img src="/home/value.svg" alt="value image" class="w-full hidden lg:flex container max-w-5xl" />
      <img src="/home/value-mo.svg" alt="value image" class="w-full container flex lg:hidden" />
    </div>
  </div>
</section>
